import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory
} from 'vue-router';
import routes from './routes';
import { sanitizeParams } from '@/util/sanitizeParams.js';

const V2_TRACKING_ID_ROUTE_NAMES = [
  'previewPostCodePage',
  'previewRealTimeTracking'
];

export function setupRouter(jsLibMode) {
  const history = jsLibMode ? createMemoryHistory() : createWebHashHistory();
  const router = createRouter({
    history,
    routes,
    scrollBehavior(to) {
      // If there's a hash in the route (e.g., #some-anchor), scroll to that
      if (to.hash) {
        const el = document.querySelector(to.hash);
        if (el) {
          return {
            el, // Element to scroll to
            behavior: 'smooth' // Optional: enable smooth scrolling
          };
        }
      }

      return { left: 0, top: 0 };
    }
  });

  router.beforeEach(to => {
    if (!V2_TRACKING_ID_ROUTE_NAMES.includes(to.name)) {
      return true;
    }

    const { params, modified } = sanitizeParams(to.params, [
      'trackingId',
      'postcode'
    ]);

    if (!modified) {
      return true;
    }

    return {
      replace: true,
      name: to.name,
      params,
      query: to.query,
      hash: to.hash
    };
  });

  return router;
}
